// Visa size groups — shared data used by the GenerateImage popover
export const VISA_GROUPS = [
    {
        key: 'visa_2x2',
        size: '2×2 inch',
        sizeBn: '২×২ ইঞ্চি',
        countries: ['যুক্তরাষ্ট্র (US)', 'ভারত'],
    },
    {
        key: 'visa_35x45',
        size: '35×45 mm',
        sizeBn: '৩৫×৪৫ মিমি',
        countries: [
            'যুক্তরাজ্য (UK)', 'শেনজেন (ইউরোপ)', 'কানাডা (ভিসা)', 'অস্ট্রেলিয়া',
            'নিউজিল্যান্ড', 'জাপান', 'সিঙ্গাপুর', 'দক্ষিণ কোরিয়া', 'থাইল্যান্ড',
            'রাশিয়া', 'পাকিস্তান', 'নেপাল', 'শ্রীলঙ্কা', 'মালদ্বীপ',
        ],
    },
    {
        key: 'visa_40x60',
        size: '40×60 mm',
        sizeBn: '৪০×৬০ মিমি',
        countries: [
            'সৌদি আরব', 'সংযুক্ত আরব আমিরাত (UAE)', 'কম্বোডিয়া', 'মিশর', 'ইরান', 'ইরাক',
            'জর্ডান', 'কুয়েত', 'লেবানন', 'মরক্কো', 'মিয়ানমার', 'ওমান',
            'ভিয়েতনাম', 'ইয়েমেন', 'বাহরাইন',
        ],
    },
    {
        key: 'visa_40x50',
        size: '40×50 mm',
        sizeBn: '৪০×৫০ মিমি',
        countries: ['হংকং', 'কাজাখস্তান', 'লিথুয়ানিয়া', 'ম্যাকাও', 'বাংলাদেশ (পাসপোর্ট)'],
    },
    {
        key: 'visa_40x40',
        size: '40×40 mm',
        sizeBn: '৪০×৪০ মিমি',
        countries: [
            'আর্জেন্টিনা', 'বলিভিয়া', 'ক্যামেরুন', 'চিলি', 'কলম্বিয়া', 'কিউবা',
            'ইকুয়েডর', 'ইথিওপিয়া', 'মেক্সিকো', 'সিরিয়া', 'উরুগুয়ে', 'ভেনেজুয়েলা',
        ],
    },
    {
        key: 'visa_50x50',
        size: '50×50 mm',
        sizeBn: '৫০×৫০ মিমি',
        countries: ['বাহামাস', 'কোস্টারিকা', 'ডোমিনিকান রিপাবলিক', 'জামাইকা', 'পানামা', 'পেরু', 'জিম্বাবুয়ে'],
    },
    {
        key: 'visa_50x70',
        size: '50×70 mm',
        sizeBn: '৫০×৭০ মিমি',
        countries: ['কানাডা (PR/পাসপোর্ট)', 'ব্রাজিল'],
    },
    {
        key: 'visa_33x48',
        size: '33×48 mm',
        sizeBn: '৩৩×৪৮ মিমি',
        countries: ['চীন'],
    },
    {
        key: 'visa_35x50',
        size: '35×50 mm',
        sizeBn: '৩৫×৫০ মিমি',
        countries: ['মালয়েশিয়া'],
    },
    {
        key: 'visa_36x47',
        size: '36×47 mm',
        sizeBn: '৩৬×৪৭ মিমি',
        countries: ['আলবেনিয়া', 'ফিনল্যান্ড', 'আইসল্যান্ড'],
    },
    {
        key: 'visa_38x48',
        size: '38×48 mm',
        sizeBn: '৩৮×৪৮ মিমি',
        countries: ['কাতার'],
    },
    {
        key: 'visa_50x60',
        size: '50×60 mm',
        sizeBn: '৫০×৬০ মিমি',
        countries: ['তুরস্ক'],
    },
];
